var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoGraficos01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCD770;}\n\t.st1{fill:#5CD6B3;}\n\t.st2{fill:#E6E9ED;}\n\t.st3{fill:#F0D0B4;}\n\t.st4{fill:#FF826E;}\n\t.st5{fill:#4D2EE6;}\n\t.st6{fill:#012F7E;}\n\t.st7{fill:#FF4A4A;}\n\t.st8{fill:#8EE26B;}\n\t.st9{fill:#444444;}\n\t.st10{fill:#292929;}\n\t.st11{fill:#FFE470;}\n\t.st12{fill:#FFDA2D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.5,31h-6.6V11.9c0-0.3,0.2-0.5,0.5-0.5H21c0.3,0,0.5,0.2,0.5,0.5L21.5,31L21.5,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21,11.3h-2.9V31h3.4V11.9C21.5,11.6,21.2,11.3,21,11.3L21,11.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.7,31H5.5c-0.4,0-0.7-0.3-0.7-0.7V14.9c0-0.4,0.3-0.7,0.7-0.7h5.3c0.4,0,0.7,0.3,0.7,0.7v15.4 C11.4,30.7,11.1,31,10.7,31L10.7,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M30.6,30.9h-5.3c-0.4,0-0.6-0.3-0.6-0.6V16.1c0-0.4,0.3-0.6,0.6-0.6h5.3c0.4,0,0.6,0.3,0.6,0.6v14.1 C31.3,30.6,31,30.9,30.6,30.9L30.6,30.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M34.1,31.4H1.9c-0.6,0-1-0.5-1-1.1s0.4-1.1,1-1.1h32.1c0.6,0,1,0.5,1,1.1C35.1,30.9,34.6,31.4,34.1,31.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M34.1,29.2h-16v2.1h16c0.6,0,1-0.5,1-1.1C35.1,29.7,34.6,29.2,34.1,29.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M34.6,8.4c0-0.4-0.2-0.9-0.8-1.1l-3.2-0.8c-0.5-0.1-1.1,0.2-1.2,0.7c-0.1,0.5,0.2,1.1,0.7,1.2L31,8.8l-2.6,1.6 l-9.8-5.6c-0.3-0.2-0.6-0.2-0.9,0L8,9.3L3.3,6.4C2.8,6.1,2.2,6.2,1.9,6.7C1.6,7.2,1.8,7.8,2.2,8.1l5.1,3.2c0.3,0.2,0.6,0.2,1,0.1 l9.8-4.6l9.9,5.6c0.3,0.1,0.6,0.2,1,0l3.1-1.9l-0.2,1c-0.2,1.3,1.6,1.7,2,0.4l0.7-3.2C34.6,8.5,34.6,8.5,34.6,8.4L34.6,8.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.8,7.4l-3.2-0.8c-0.5-0.1-1.1,0.2-1.2,0.7c-0.1,0.5,0.2,1.1,0.7,1.2L31,8.8l-2.6,1.6l-9.8-5.6 c-0.2-0.1-0.4-0.1-0.5-0.1v2.1l0,0l9.9,5.6c0.3,0.1,0.6,0.2,1,0l3.1-1.9l-0.2,1c-0.2,1.3,1.6,1.7,2,0.4l0.7-3.2c0,0,0,0,0-0.1 C34.6,8,34.4,7.5,33.8,7.4L33.8,7.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGraficos01);
export default __webpack_public_path__ + "static/media/ico-graficos-01.724d018808956945c3251fbde88320d2.svg";
export { ForwardRef as ReactComponent };